import React, { useState } from 'react';
import CustomTabs from 'components/CustomTabs';
import CustomNotificationTable from '../Notifications/components/AllNotification/CustomNotificationStatic';
import WhatsAppAnalytics from './WhatsAppMessage';
import DateRangeFilter from './DateRangeFilter';
import ReportTab from './ReportTab';
import DailyPriceSharing from './DailyPriceSharing';
import PushNotification from './PushNotification';
import './Analytics.css';

const Analytics = () => {
  const tabs = [
    'Custom Notifications',
    'WhatsApp Messages',
    'Report',
    'Daily Price Analytics',
    'Push Notification',
  ];
  const [selectedTab, setSelectedTab] = useState('Custom Notifications');
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });

  const handleFilter = ({ startDate, endDate }) => {
    setDateRange({ startDate, endDate });
  };

  return (
    <div className="analytics-page">
      {/* Header with Tabs and Filter aligned */}
      <div className="analytics-header">
        <div className="header-content">
          {/* Tabs on the left */}
          <div className="custom-tabs-wrapper">
            <CustomTabs
              tabs={tabs}
              selectedTab={selectedTab}
              onTabChange={setSelectedTab}
              className="mb-0"
            />
          </div>

          {/* Filter on the right, aligned with tabs */}
          {(selectedTab === 'WhatsApp Messages' || selectedTab === 'Push Notification') && (
            <div className="filter-wrapper">
              <DateRangeFilter onFilter={handleFilter} dateRange={dateRange} />
            </div>
          )}
        </div>
      </div>

      {/* Content Area */}
      <div className={`analytics-container ${selectedTab === 'Push Notification' ? 'analytics-container--push-notification' : ''}`}>
        {selectedTab === 'Custom Notifications' && (
          <CustomNotificationTable isDrawer={false} />
        )}
        {selectedTab === 'WhatsApp Messages' && (
          <WhatsAppAnalytics dateRange={dateRange} />
        )}
        {selectedTab === 'Report' && <ReportTab />}
        {selectedTab === 'Daily Price Analytics' && <DailyPriceSharing />}
        {selectedTab === 'Push Notification' && <PushNotification dateRange={dateRange} />}
      </div>
    </div>
  );
};

export default Analytics;
